import { useState } from "react";
import Oracel_services from "../../../Assets/Oracel_service_header.png";
import jobsData from '../../../utils/Jobs.json'
import { useParams } from "react-router-dom";
import { Mail, Send } from 'lucide-react';

const Description = () => {
  const [careerApply, setCareerApply] = useState({
    fullname: "",
    email: "",
    countrycode: "",
    mobilenumber: "",
    applyto: "",
    experience: "",
    previoussalary: "",
    exceptedsalary: "",
    noticeperiod: "",
    location: "",
    willingToRelocate: "",
    referredBy: "",
    resume: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCareerApply({ ...careerApply, [name]: value });
    if (value && errors[name]) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const validateForm = () => {
    let formErrors = {};

    // Validate Full Name
    if (!careerApply.fullname) {
      formErrors.fullname = "Full Name is required";
    }

    // Validate Email
    if (!careerApply.email) {
      formErrors.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(careerApply.email)) {
      formErrors.email = "Email is invalid";
    }

    // Validate Mobile Number
    if (!careerApply.mobilenumber) {
      formErrors.mobilenumber = "Mobile number is required";
    } else if (!/^\d+$/.test(careerApply.mobilenumber)) {
      formErrors.mobilenumber = "Mobile Number must contain only digits";
    } else if (careerApply.mobilenumber.length !== 10) {
      formErrors.mobilenumber = "Mobile Number must be exactly 10 digits";
    }

    // Validate Applied Position
    if (!careerApply.applyto) {
      formErrors.applyto = "Please select a position to apply";
    }

    // Validate Experience
    if (!careerApply.experience) {
      formErrors.experience = "Experience is required";
    }

    // Validate Current CTC
    if (!careerApply.previoussalary) {
      formErrors.previoussalary = "Current CTC is required";
    }

    // Validate Expected CTC
    if (!careerApply.exceptedsalary) {
      formErrors.exceptedsalary = "Expected CTC is required";
    }

    // Validate Notice Period
    if (!careerApply.noticeperiod) {
      formErrors.noticeperiod = "Notice period is required";
    }

    // Validate Location
    if (!careerApply.location) {
      formErrors.location = "Location is required";
    }

    // Validate Willing to Relocate
    if (!careerApply.willingToRelocate) {
      formErrors.willingToRelocate = "Please select your relocation preference";
    }

    // Validate Referral
    if (!careerApply.referredBy) {
      formErrors.referredBy = "Referral option is required";
    }

    // Validate Resume Upload
    if (!careerApply.resume) {
      formErrors.resume = "Resume is required";
    }

    setErrors(formErrors);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted successfully!", careerApply);
    } else {
      console.log("Validation errors:", errors);
    }
  };

  const { id } = useParams(); 
  const job = jobsData.jobs.find((job) => job.jobId === id);

  if (!job) {
    return (
      <div className="p-10 text-center text-red-600">
        Job not found
      </div>
    );
  }


    {/* Helper Components */}
    const DetailItem = ({ label, value, icon }) => (
      <div className="flex items-start space-x-3">
        <span className="text-xl mt-0.5">{icon}</span>
        <div>
          <span className="font-man font-extrabold text-md" style={{ color: "#374151" }}>{label}:</span> {/* gray-700 */}
          <span className="ml-1" style={{ color: "#4b5563" }}>{value}</span> {/* gray-600 */}
        </div>
      </div>
    );

    const Section = ({ title, icon, children, className = "" }) => {
      if (!children) return null;
      return (
        <div className={className}>
          <h3 className="text-xl font-man font-bold mb-4 flex items-center" style={{ color: "#468FEA" }}> {/* indigo-800 */}
            <span
              className="w-8 h-8 rounded-full flex items-center justify-center mr-3"
              style={{ backgroundColor: "#e0e7ff", color: "#4f46e5" }} // indigo-100 / indigo-600
            >
              {icon}
            </span>
            {title}
          </h3>
          {children}
        </div>
      );
    };

    const ResponsibilitySection = ({ title, points }) => {
      if (!points || points.length === 0) return null;
      return (
        <div className="mb-5 last:mb-0">
          <h4 className="font-bold font-man mb-2 text-lg" style={{ color: "#4B5563" }}>{title}</h4> {/* gray-800 */}
          <ul className="space-y-1 ml-2">
            {points.map((point, i) => (
              <li key={i} className="flex items-start">
                <span className="mr-2 mt-1" style={{ color: "#4B5563" }}>•</span> {/* indigo-500 */}
                <span style={{ color: "#4b5563", lineHeight: "1.5" }}>{point}</span> {/* gray-600 */}
              </li>
            ))}
          </ul>
        </div>
      );
    };

    const SkillCategory = ({ title, skills }) => {
      if (!skills || skills.length === 0) return null;
      return (
        <div className="mb-4 last:mb-0">
          <h4 className="font-semibold mb-2 text-lg" style={{ color: "#4B5563" }}>{title}</h4> {/* gray-800 */}
          <ul className="space-y-1 ml-2">
            {skills.map((skill, i) => (
              <li key={i} className="flex items-start">
                <span className="mr-2 mt-1" style={{ color: "#4B5563" }}>•</span> {/* indigo-500 */}
                <span style={{ color: "#4b5563" }}>{skill}</span> {/* gray-600 */}
              </li>
            ))}
          </ul>
        </div>
      );
    };

  return (
    <div>

      <section
        className="
          py-16 md:py-48
          bg-[url('https://ik.imagekit.io/7wqj9br0b/PTKCS/Career%20Page/joinus.png')]
          bg-center
          bg-no-repeat
          bg-contain
          md:bg-cover
        "
      >
      <div className="container mx-auto px-4 text-center font-md">
        <h1
          className="text-5xl font-semibold mb-4"
          style={{ color: "#ffffff"}} // white
        >
        </h1>
      </div>
    </section>

      {/* <section className="bg-[#efefef] ">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-10  xl:mx-40 mx-3 md:mx-6 ">
          <div className="col-span-1 xl:my-auto  py-5 order-2 lg:order-1">
            <h1 className="">Career</h1>
            <h2>
              Together, as owners, let’s turn meaningful insights into action
            </h2>
            <p className="text-paracolor">
              Join a company rooted in ownership, teamwork, respect and
              belonging. Be part of our company of owners, where you’ll benefit
              from the rewards of our collective success, while working
              side-by-side with colleagues and clients to solve complex issues.
            </p>
          </div>
          <div className="col-span-1 flex items-center justify-center order-1 lg:order-2 image_design">
            <img
              src={Oracel_services}
              alt="Oracel_services"
              className="w-full h-full"
            />
          </div>
        </div>
      </section> */}




    <div className="w-full flex justify-center pt-12">
      <div
        className="border rounded-2xl p-6 shadow-sm w-full max-w-xl"
        style={{
          background: 'linear-gradient(135deg, #f9fafb, #eff6ff)',
          borderColor: '#e5e7eb'
        }}
      >
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-4">
            <div
              className="inline-flex items-center justify-center w-12 h-12 border-2 border-dashed rounded-full"
              style={{
                backgroundColor: '#ffffff',
                borderColor: '#93c5fd'
              }}
            >
              <Send
                className="w-6 h-6"
                strokeWidth={2}
                style={{ color: '#2563eb' }}
              />
            </div>

            <div>
              <h4
                className="font-semibold text-base mb-1"
                style={{ color: '#1f2937' }}
              >
                Submit Your Resume
              </h4>

              <p
                className="text-xs"
                style={{ color: '#6b7280' }}
              >
                We'd love to hear from you
              </p>
            </div>
          </div>

          <a
            href="mailto:info@kcs-tech.com"
            className="inline-flex items-center gap-2 font-medium text-sm transition-colors duration-200"
            style={{ color: '#2563eb' }}
            onMouseOver={e => (e.currentTarget.style.color = '#1e40af')}
            onMouseOut={e => (e.currentTarget.style.color = '#2563eb')}
          >
            <Mail className="w-4 h-4" />
            <span>info@kcs-tech.com</span>
          </a>
        </div>
      </div>
    </div>

      
      <section className="py-10 font-md">
        <div className="xl:mx-40 mx-3 md:mx-6 ">

        {/* Job Requirements Description part------------------------ */}
        <div
          className="col-span-2 p-8 "
        >
          {/* Job Title */}
          <h2
            className="text-3xl font-md mb-6 pb-2 border-b-2"
            style={{
              color: "#0070FF", // indigo-900
              borderColor: "#e0e7ff" // indigo-100
            }}
          >
            {job.jobTitle}
          </h2>

          {/* Job Details Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <DetailItem label="Category" value={job.category} icon="📋" />
            <DetailItem label="Location" value={job.location} icon="📍" />
            <DetailItem label="Position" value={job.position} icon="💼" />
            {typeof job.openings === "number" && (
              <DetailItem label="Openings" value={job.openings} icon="#" />
            )}
            <DetailItem label="Employment Type" value={job.employmentType} icon="⏱️" />
            <DetailItem label="Experience" value={job.experienceLevel} icon="🎓" />
            {/* <DetailItem label="Salary Range" value={job.salaryRange} icon="💰" /> */}
          </div>

          <hr className="my-6" style={{ borderColor: "#e5e7eb" }} /> {/* gray-200 */}

          {/* Job Summary */}
          <div className="mb-8">
            <h3 className="text-xl font-bold font-man mb-3 flex items-center" style={{color:'#468FEA'}}>
              <span
                className="w-8 h-8 rounded-full flex items-center justify-center mr-3"
                style={{ backgroundColor: "#e0e7ff", color: "#4f46e5" }} // indigo-100 / indigo-600
              >
                ℹ️
              </span>
              Description
            </h3>
            <p style={{ color: "#4b5563", lineHeight: "1.6" }}>{job.jobSummary}</p> {/* gray-600 */}
          </div>

          {/* Key Responsibilities */}
          {job.keyResponsibilities && (
            <Section title="Key Responsibilities" icon="🎯">
              
              {/* CASE 1: Array of structured objects (ABAP job etc.) */}
              {Array.isArray(job.keyResponsibilities) &&
                job.keyResponsibilities.length > 0 &&
                typeof job.keyResponsibilities[0] === "object" &&
                job.keyResponsibilities.map((section, idx) => (
                  <ResponsibilitySection
                    key={idx}
                    title={section.title}
                    points={section.points}
                  />
                ))}

              {/* CASE 2: Simple string array (SAP B1 job etc.) */}
              {Array.isArray(job.keyResponsibilities) &&
                job.keyResponsibilities.length > 0 &&
                typeof job.keyResponsibilities[0] === "string" && (
                  <ResponsibilitySection
                    title="Core Responsibilities"
                    points={job.keyResponsibilities}
                  />
                )}

              {/* CASE 3: Object map format (like SuccessFactors job) */}
              {!Array.isArray(job.keyResponsibilities) &&
                typeof job.keyResponsibilities === "object" &&
                Object.entries(job.keyResponsibilities).map(([title, points]) => (
                  <ResponsibilitySection
                    key={title}
                    title={title}
                    points={points}
                  />
                ))}

            </Section>
          )}



          {/* Required Skills */}
          {job.requiredSkills && (
            <Section title="Required Skills" icon="🛠️" className="mt-8">
              
              {/* CASE 1: Object-based skills (Technical + Functional) */}
              {typeof job.requiredSkills === "object" && !Array.isArray(job.requiredSkills) && (
                <>
                  {job.requiredSkills.technicalSkills && (
                    <SkillCategory
                      title="Technical Skills"
                      skills={job.requiredSkills.technicalSkills}
                    />
                  )}

                  {job.requiredSkills.functionalSkills && (
                    <SkillCategory
                      title="Functional Skills"
                      skills={job.requiredSkills.functionalSkills}
                    />
                  )}
                </>
              )}

              {/* CASE 2: Array-based skills (Single list) */}
              {Array.isArray(job.requiredSkills) && (
                <SkillCategory
                  title="Core Skills"
                  skills={job.requiredSkills}
                />
              )}

            </Section>
          )}


          {/* Tags */}
          {job.tags && job.tags.length > 0 && (
            <div className="mt-8">
              <h4 className="text-lg font-bold font-man mb-3" style={{ color: "#468FEA" }}>Tags</h4> {/* gray-800 */}
              <div className="flex flex-wrap gap-2">
                {job.tags.map((tag, idx) => (
                  <span
                    key={idx}
                    className="px-3 py-1 rounded-full text-sm font-medium transition-colors duration-200"
                    style={{
                      backgroundColor: "#e0e7ff", // indigo-100
                      color: "#3730a3", // indigo-800
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

          
          {/* <div className="col-span-1">
            <form
              className="bg-white shadow p-6 rounded-md"
              onSubmit={handleSubmit}
            >
              <h2>Apply Here</h2>

             
              <div className="w-full mb-3">
                <input
                  type="text"
                  name="fullname"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  placeholder="Full Name"
                  value={careerApply.fullname}
                  onChange={handleChange}
                />
                <div className="h-3">
                  {errors.fullname && (
                    <span className="text-xs text-red ">{errors.fullname}</span>
                  )}
                </div>
              </div>

           
              <div className="w-full mb-3">
                <input
                  type="email"
                  name="email"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  placeholder="Email"
                  value={careerApply.email}
                  onChange={handleChange}
                />

                <div className="h-3">
                  {errors.email && (
                    <span className="text-xs text-red ">{errors.email}</span>
                  )}
                </div>
              </div>

            
              <div className="w-full mb-3">
                <input
                  type="number"
                  name="mobilenumber"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  placeholder="Mobile"
                  value={careerApply.mobilenumber}
                  onChange={handleChange}
                />

                <div className="h-3">
                  {errors.mobilenumber && (
                    <span className="text-xs text-red ">
                      {errors.mobilenumber}
                    </span>
                  )}
                </div>
              </div>

         
              <div className="w-full mb-3">
                <select
                  name="applyto"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  value={careerApply.applyto}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Applied to
                  </option>
                  <option>Software Developer</option>
                  <option>Content Writer</option>
                  <option>Digital Marketing</option>
                </select>

                <div className="h-3">
                  {errors.applyto && (
                    <span className="text-xs text-red ">{errors.applyto}</span>
                  )}
                </div>
              </div>

            
              <div className="w-full mb-4">
                <select
                  name="experience"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  value={careerApply.experience}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Experience (Years)
                  </option>
                  <option>0-1</option>
                  <option>1-2</option>
                  <option>2-3</option>
                </select>
                <div className="h-3">
                  {errors.experience && (
                    <span className="text-xs text-red ">
                      {errors.experience}
                    </span>
                  )}
                </div>
              </div>

       
              <div className="w-full mb-4">
                <input
                  type="number"
                  name="previoussalary"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  placeholder="Current CTC"
                  value={careerApply.previoussalary}
                  onChange={handleChange}
                />

                <div className="h-3">
                  {errors.previoussalary && (
                    <span className="text-xs text-red ">
                      {errors.previoussalary}
                    </span>
                  )}
                </div>
              </div>

    
              <div className="w-full mb-4">
                <input
                  type="number"
                  name="exceptedsalary"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  placeholder="Expected CTC"
                  value={careerApply.exceptedsalary}
                  onChange={handleChange}
                />
                <div className="h-3">
                  {errors.exceptedsalary && (
                    <span className="text-xs text-red ">
                      {errors.exceptedsalary}
                    </span>
                  )}
                </div>
              </div>

          
              <div className="w-full mb-4">
                <select
                  name="noticeperiod"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  value={careerApply.noticeperiod}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Notice Period
                  </option>
                  <option>Immediate Joiner</option>
                  <option>15 days</option>
                  <option>30 days</option>
                  <option>60 days</option>
                </select>

                <div className="h-3">
                  {errors.noticeperiod && (
                    <span className="text-xs text-red ">
                      {errors.noticeperiod}
                    </span>
                  )}
                </div>
              </div>

      
              <div className="w-full mb-4">
                <input
                  type="text"
                  name="location"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  placeholder="Location"
                  value={careerApply.location}
                  onChange={handleChange}
                />

                <div className="h-3">
                  {errors.location && (
                    <span className="text-xs text-red ">{errors.location}</span>
                  )}
                </div>
              </div>

         
              <div className="w-full mb-4">
                <select
                  name="willingToRelocate"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                  value={careerApply.willingToRelocate}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Willing to relocate?
                  </option>
                  <option>Yes</option>
                  <option>No</option>
                </select>

                <div className="h-3">
                  {errors.willingToRelocate && (
                    <span className="text-xs text-red ">
                      {errors.willingToRelocate}
                    </span>
                  )}
                </div>
              </div>

              <label className="text-base mb-1">
                Referred by internal employee?
              </label>

              <div>
                <div className="w-full  flex">
                  <label>
                    <input
                      type="radio"
                      name="referredBy"
                      value="yes"
                      checked={careerApply.referredBy === "yes"}
                      onChange={handleChange}
                    />
                    Yes
                  </label>
                  <label className="ml-4">
                    <input
                      type="radio"
                      name="referredBy"
                      value="no"
                      checked={careerApply.referredBy === "no"}
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
                <div className="h-3 mb-4">
                  {errors.referredBy && (
                    <span className="text-xs text-red ">
                      {errors.referredBy}
                    </span>
                  )}
                </div>
              </div>


              <label className="text-base"> Resume</label>
              <div className="w-full mb-4">
                <input
                  type="file"
                  name="resume"
                  className="contact_form w-full p-3 rounded-md shadow-sm border"
                />

                <div className="h-3 ">
                  {errors.resume && (
                    <span className="text-xs text-red ">{errors.resume}</span>
                  )}
                </div>
              </div>

              <button
                type="submit"
                className="border  bg-[#4e8ecb] rounded-md py-2 px-4 text-[#fff] mb-2 "
              >
                Submit
              </button>
            </form>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default Description;
